import { gql } from "@apollo/client";

const schema = {
  current: {
    name: "city",
    serviceName: "graphql",
    query: gql`
      query city($ids: [String]) {
        city(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
